const nameToken = "JARU_TOKEN";
const emailStore = "JARU_EMAIL";
const rolesModules = ["super-admin", "admin", "executor"];
export { nameToken, emailStore, rolesModules };
